import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "default-content" }
const _hoisted_3 = { class: "collapse-content" }
const _hoisted_4 = { class: "collapse-content" }
const _hoisted_5 = { class: "collapse-content" }
const _hoisted_6 = { class: "collapse-content" }
const _hoisted_7 = { class: "new-form" }

export function render(_ctx, _cache) {
  const _component_Header = _resolveComponent("Header")
  const _component_Navigation = _resolveComponent("Navigation")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _component_Memo = _resolveComponent("Memo")
  const _component_el_icon = _resolveComponent("el-icon")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_Check = _resolveComponent("Check")
  const _component_el_button = _resolveComponent("el-button")
  const _component_Delete = _resolveComponent("Delete")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")
  const _component_CirclePlusFilled = _resolveComponent("CirclePlusFilled")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_collapse = _resolveComponent("el-collapse")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header, {
      windowWidth: _ctx.windowWidth,
      windowHeight: _ctx.windowHeight
    }, null, 8, ["windowWidth", "windowHeight"]),
    _createVNode(_component_Navigation, {
      activeMenu: _ctx.NavigationIndex.CATEGORY,
      windowWidth: _ctx.windowWidth,
      windowHeight: _ctx.windowHeight
    }, null, 8, ["activeMenu", "windowWidth", "windowHeight"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createVNode(_component_el_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_main, null, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [
                _createElementVNode("div", { class: "danger" }, [
                  _createElementVNode("h4", null, "Zugang verweigert."),
                  _createElementVNode("p", null, "Sie besitzen nicht die erforderliche Berechtigung für diesen Bereich.")
                ], -1)
              ])),
              _: 1
            })
          ]),
          _: 1
        }, 512), [
          [_vShow, !_ctx.hasPermission['CATG_SELECT'] && !_ctx.loading]
        ]),
        (_ctx.hasPermission['CATG_SELECT'])
          ? (_openBlock(), _createBlock(_component_el_container, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_main, { class: "rounded-content" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_collapse, {
                      modelValue: _ctx.activeName,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.activeName) = $event)),
                      accordion: "",
                      ref: "coll"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_collapse_item, { name: "1" }, {
                          title: _withCtx(() => [
                            _createElementVNode("div", _hoisted_3, [
                              _createVNode(_component_el_icon, { size: 32 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Memo)
                                ]),
                                _: 1
                              })
                            ]),
                            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "title-label" }, "Kategorien", -1))
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_4, [
                              _withDirectives((_openBlock(), _createBlock(_component_el_table, { data: _ctx.categoryModelList }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_table_column, {
                                    prop: "categoryid",
                                    label: "ID",
                                    width: "80"
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    prop: "name",
                                    label: "Bezeichnung"
                                  }, {
                                    default: _withCtx((scope) => [
                                      _createVNode(_component_el_input, {
                                        modelValue: _ctx.categoryModelList[scope.$index].name,
                                        "onUpdate:modelValue": $event => ((_ctx.categoryModelList[scope.$index].name) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    prop: "description",
                                    label: "Beschreibung"
                                  }, {
                                    default: _withCtx((scope) => [
                                      _createVNode(_component_el_input, {
                                        modelValue: _ctx.categoryModelList[scope.$index].description,
                                        "onUpdate:modelValue": $event => ((_ctx.categoryModelList[scope.$index].description) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    prop: "parentid",
                                    label: "Unterkategorie von"
                                  }, {
                                    default: _withCtx((scope) => [
                                      _createVNode(_component_el_select, {
                                        modelValue: _ctx.categoryModelList[scope.$index].parentid,
                                        "onUpdate:modelValue": $event => ((_ctx.categoryModelList[scope.$index].parentid) = $event),
                                        placeholder: "[keine]"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_option, {
                                            key: "0",
                                            label: "[keine]",
                                            value: 0
                                          }),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryModelList, (item) => {
                                            return (_openBlock(), _createBlock(_component_el_option, {
                                              key: item.categoryid,
                                              label: item.name,
                                              value: item.categoryid
                                            }, null, 8, ["label", "value"]))
                                          }), 128))
                                        ]),
                                        _: 2
                                      }, 1032, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    prop: "dateupdate",
                                    label: "Letzte Änderung",
                                    width: "200"
                                  }, {
                                    default: _withCtx((scope) => [
                                      _createTextVNode(_toDisplayString(new Intl.DateTimeFormat('de-DE', {year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit'}).format(new Date(0).setUTCSeconds(_ctx.categoryModelList[scope.$index].dateupdate))), 1)
                                    ]),
                                    _: 1
                                  }),
                                  (_ctx.hasPermission['CATG_UPDATE'])
                                    ? (_openBlock(), _createBlock(_component_el_table_column, {
                                        key: 0,
                                        fixed: "right",
                                        label: "",
                                        width: "60"
                                      }, {
                                        default: _withCtx((scope) => [
                                          _createVNode(_component_el_button, {
                                            type: "success",
                                            onClick: $event => (_ctx.onCategorySaveClick(_ctx.categoryModelList[scope.$index])),
                                            circle: ""
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_el_icon, { size: 16 }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_Check)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"])
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  (_ctx.hasPermission['CATG_DELETE'])
                                    ? (_openBlock(), _createBlock(_component_el_table_column, {
                                        key: 1,
                                        fixed: "right",
                                        label: "",
                                        width: "60"
                                      }, {
                                        default: _withCtx((scope) => [
                                          _createVNode(_component_el_button, {
                                            type: "danger",
                                            onClick: $event => (_ctx.onCategoryDeleteClick(_ctx.categoryModelList[scope.$index])),
                                            circle: ""
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_el_icon, { size: 16 }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_Delete)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"])
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }, 8, ["data"])), [
                                [_directive_loading, _ctx.loading]
                              ])
                            ])
                          ]),
                          _: 1
                        }),
                        (_ctx.hasPermission['CATG_INSERT'])
                          ? (_openBlock(), _createBlock(_component_el_collapse_item, {
                              key: 0,
                              name: "2"
                            }, {
                              title: _withCtx(() => [
                                _createElementVNode("div", _hoisted_5, [
                                  _createVNode(_component_el_icon, { size: 32 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_CirclePlusFilled)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _cache[6] || (_cache[6] = _createElementVNode("div", { class: "title-label" }, "Neue Kategorie", -1))
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_6, [
                                  _createElementVNode("div", _hoisted_7, [
                                    _createVNode(_component_el_form, {
                                      ref: "newCategoryForm",
                                      rules: _ctx.rules,
                                      "label-position": "top",
                                      model: _ctx.newCategoryModel,
                                      "label-width": "120px"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_form_item, {
                                          label: "Bezeichnung",
                                          prop: "name"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_input, {
                                              modelValue: _ctx.newCategoryModel.name,
                                              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.newCategoryModel.name) = $event)),
                                              onInput: _ctx.onInput
                                            }, null, 8, ["modelValue", "onInput"])
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_form_item, {
                                          label: "Beschreibung",
                                          prop: "description"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_input, {
                                              modelValue: _ctx.newCategoryModel.description,
                                              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.newCategoryModel.description) = $event)),
                                              onInput: _ctx.onInput
                                            }, null, 8, ["modelValue", "onInput"])
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_form_item, { label: "Unterkategorie von" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_select, {
                                              modelValue: _ctx.newCategoryModel.parentid,
                                              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.newCategoryModel.parentid) = $event)),
                                              placeholder: "[keine]"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_el_option, {
                                                  key: "0",
                                                  label: "[keine]",
                                                  value: 0
                                                }),
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryModelList, (item) => {
                                                  return (_openBlock(), _createBlock(_component_el_option, {
                                                    key: item.categoryid,
                                                    label: item.name,
                                                    value: item.categoryid
                                                  }, null, 8, ["label", "value"]))
                                                }), 128))
                                              ]),
                                              _: 1
                                            }, 8, ["modelValue"])
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_form_item, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_button, {
                                              type: "primary",
                                              disabled: !_ctx.formValid,
                                              onClick: _ctx.onNewCategoryClick
                                            }, {
                                              default: _withCtx(() => _cache[7] || (_cache[7] = [
                                                _createTextVNode("Hinzufügen ")
                                              ])),
                                              _: 1
                                            }, 8, ["disabled", "onClick"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["rules", "model"])
                                  ])
                                ])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}